export default __webpack_public_path__ + "static/897-5231425c0ab8d89bb9ec512719f66a66.gif";